import { type FC } from 'react'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { ProductCarouselFocusProvider } from './ProductCarouselGalleryWithThumbnails/ProductCarouselFocusContext'
import { ProductCarouselLargeCarousel } from './ProductCarouselLargeCarousel'
import { type ProductCarouselLargeGalleryModalProps } from './ProductCarouselLargeGalleryModalProps'

const ProductCarouselLargeGalleryModal: FC<
  ProductCarouselLargeGalleryModalProps
> = ({
  images,
  initialIndex,
  isOpen,
  onClose,
  playVideoOnScrolledIntoView,
  productName,
  videos,
}) => {
  return (
    <Dialog
      onClose={onClose}
      open={isOpen}
      slotProps={{
        dialog: {
          className: 'w-full max-w-2xl',
        },
      }}
    >
      <DialogTitle onClose={onClose}>{productName}</DialogTitle>
      <DialogContent className="flex items-center justify-center overflow-hidden bg-light-primary-low">
        <ProductCarouselFocusProvider>
          <ProductCarouselLargeCarousel
            images={images}
            initialIndex={initialIndex}
            isOpen={isOpen}
            playVideoOnScrolledIntoView={playVideoOnScrolledIntoView}
            productName={productName}
            videos={videos}
          />
        </ProductCarouselFocusProvider>
      </DialogContent>
    </Dialog>
  )
}

export { ProductCarouselLargeGalleryModal }
